// Where a camera's stream URL came from (backend `url_source`), for a small chip
// in the camera lists and a line under the URL in Edit Camera. Lets support tell
// a URL the camera gave itself (ONVIF) from one we built from a brand template —
// the template ones are where sub-stream and stream-settings problems come from.
// Cameras added before this was recorded have none, and show nothing.
export function urlSourceLabel(src, typeLabels = {}) {
  if (!src) return null;
  if (src === 'onvif') return { short: '🔗 ONVIF', long: 'Given by the camera (ONVIF)' };
  if (src === 'open')  return { short: '🔗 ONVIF · no password', long: 'Given by the camera (ONVIF), no password needed' };
  if (src === 'manual') return { short: '✏️ Typed URL', long: 'Typed in by hand' };
  if (src.startsWith('template:')) {
    const key   = src.slice('template:'.length);
    const brand = typeLabels[key] || key.charAt(0).toUpperCase() + key.slice(1);
    return { short: `🧩 Template: ${brand}`, long: `Built from the ${brand} URL template` };
  }
  return null;
}

// Probe result → url_source to save with the camera.
export function urlSourceFromProbe(method) {
  if (method === 'ONVIF') return 'onvif';
  if (typeof method === 'string' && method.startsWith('template:')) return method;
  return 'manual';   // "direct": a URL someone typed and tested
}
